import { useFloating, offset, flip, shift } from '@floating-ui/react';
import { Menu } from '@headlessui/react';
import { IconMoreHorizontal } from '@iwoca/icons';
import { Button } from '@iwoca/orion';
import { createPortal } from 'react-dom';
import styles from './RowActionsMenu.module.css';

type TProps = {
  onEdit: () => void;
};

export const RowActionsMenu = ({ onEdit }: TProps) => {
  const { refs, floatingStyles } = useFloating({
    placement: 'bottom-end',
    middleware: [offset(4), flip(), shift({ padding: 8 })],
  });

  return (
    <Menu>
      {({ open }) => (
        <>
          <Menu.Button
            as={Button}
            variant="tertiary"
            iconOnly
            aria-label="Row actions"
            ref={refs.setReference}
            className={styles.trigger}
          >
            <IconMoreHorizontal className={styles.triggerIcon} />
          </Menu.Button>
          {open &&
            createPortal(
              <Menu.Items
                static
                className={styles.panel}
                ref={refs.setFloating}
                style={floatingStyles}
              >
                <Menu.Item
                  as="button"
                  type="button"
                  className={styles.item}
                  onClick={onEdit}
                >
                  Edit
                </Menu.Item>
                {/* TODO: add Deactivate when the deactivate flow ships */}
              </Menu.Items>,
              document.body,
            )}
        </>
      )}
    </Menu>
  );
};
